import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import NextDraft from './NextDraft.js';
import Notification from './Notification.js';

class Home extends Component {

  render() {
    return (
      <Row>
        <Col sm={12}>
          <h1>Welcome to Fantasy Fitness Draft</h1>
        </Col>
        <Col>
          <p>&nbsp;</p>
        </Col>
        <NextDraft />
        <Notification />
      </Row>
    );
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js